/**
 * Created by fers on 05.02.16.
 */
import React from 'react';
import PropTypes from 'prop-types';

import {FormattedMessage, IntlShape} from 'react-intl';
import Link from 'react-router/lib/Link';

import config from '../../common/config';
import Relay from 'react-relay';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import * as Permission from '../../common/util/Permission';
import * as BrowserPermission from '../BrowserPermission';
import * as FeatureFlags from '../../common/util/FeatureFlags.ts';
import {getLocale} from '../locales';
import EventTracker from './EventTracker';
import ChannelIcon from '../channel-defs/ChannelIcon.react';
import { User } from '../../common/types/types';

interface LeftNavRootProps {
 currentOrganisation?: object;
 toggleLeftMenu?: (...args: unknown[]) => unknown;
 user: User;
}

class LeftNavRoot extends React.Component<LeftNavRootProps> {

    static propTypes = {
        currentOrganisation: PropTypes.object,
        toggleLeftMenu: PropTypes.func,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        EventTracker.initEventTracker(props.user);
    }

    render() {

        let logged = [];

        let loggedBottom = [];

        let linkProps = {
            activeClassName: 'active',
            onClick: () => {this.props.toggleLeftMenu();},
        };

        if (this.props.currentOrganisation) {
            logged.push(<li key="myDativery"><Link {...linkProps} onlyActiveOnIndex to={urlMapping.getUrl(types['channels'], 'list', this.props.currentOrganisation)}><i className="fa fa-fw fa-link" ></i>&nbsp; <FormattedMessage defaultMessage="My Organisation" id="menu.home2" /></Link></li>);

            if (FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_CAN_SEE_USERS, this.props.user)) {
                logged.push(<li key="users"><Link {...linkProps} to={urlMapping.getUrl(types['users'], 'list', this.props.currentOrganisation)}><i className="fa fa-fw fa-users"></i>&nbsp; <FormattedMessage defaultMessage="Users" id="menu.users" /></Link></li>);
            }

            if (FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_TASKS, this.props.user)) {
                logged.push(<li key="tasks"><Link {...linkProps} to={urlMapping.getUrl(types['tasks'], 'list', this.props.currentOrganisation)}><i className="fa fa-fw fa-checklist"></i>&nbsp; <FormattedMessage defaultMessage="My Tasks" id="menu.tasks" /></Link></li>);
            }

            logged.push(<li key="org-errors"><Link {...linkProps} to={urlMapping.getUrl(types['channelErrors'], 'list-org-type', this.props.currentOrganisation)}><i className="fa fa-fw fa-exclamation-circle"></i>&nbsp; <FormattedMessage defaultMessage="Errors" id="channelErrors.list" /></Link></li>);
            logged.push(<li key="org-invoices"><Link {...linkProps} to={urlMapping.getUrl('invoices', 'list', this.props.currentOrganisation)}><i className="fa fa-fw fa-file-text-o"></i>&nbsp; <FormattedMessage defaultMessage="Invoices" id="invoices.list" /></Link></li>);
            logged.push(<li key="org-tariffs"><Link {...linkProps} to={urlMapping.getUrl(types['tariffs'], 'list', this.props.currentOrganisation)}><i className="fa fa-fw fa-credit-card"></i>&nbsp; <FormattedMessage defaultMessage="Support tariffs" id="tariffs.list" /></Link></li>);

            logged.push(<li className="nav-divider" key="separator-org" role="separator"></li>);
        } else {
            logged.push(<li key="organisationList"><Link onClick={linkProps.onClick} to="/organisations/"><i className="fa fa-fw fa-sitemap"></i>&nbsp; <FormattedMessage defaultMessage="Organisations" id="home.organisations" /></Link></li>);
        }

        logged.push(<li key="applications"><Link {...linkProps} to="/apps/"><i className="fa fa-fw fa-book"></i>&nbsp; <FormattedMessage defaultMessage="Applications" id="menu.apps" /></Link></li>);
        logged.push(<li key="scenarios"><Link {...linkProps} to="/s/"><i className="fa fa-fw fa-newspaper-o"></i>&nbsp; <FormattedMessage defaultMessage="Integration Scenarios" id="menu.scenarios" /></Link></li>);

        if ((BrowserPermission.hasPermission(Permission.PERM_EDIT_CHANNEL_DEF) || FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_DEV_PORTAL, this.props.user)) && BrowserPermission.developerModeEnabled()) {
            logged.push(<li className="nav-divider" key="separator2" role="separator"></li>);

            logged.push(<li key="channelDefs"><Link {...linkProps} to="/channel-defs/"><i className="fa fa-fw fa-book"></i>&nbsp; <FormattedMessage defaultMessage="Application Definitions" id="channelDefs.list" /></Link></li>);
            if (BrowserPermission.hasPermission(Permission.PERM_EDIT_CHANNEL_DEF)) {
                logged.push(<li key="groupDefs"><Link {...linkProps} to="/group-defs/"><i className="fa fa-fw fa-cubes"></i>&nbsp; <FormattedMessage defaultMessage="Model Definitions" id="groupDefs.list" /></Link></li>);
            }
            logged.push(<li key="scenarioDefs"><Link {...linkProps} to="/scenario-defs/"><i className="fa fa-fw fa-newspaper-o"></i>&nbsp; <FormattedMessage defaultMessage="Scenario Definitions" id="scenarioDefs.list" /></Link></li>);

            logged.push(<li key="flowDefs"><Link {...linkProps} to="/flow-defs/"><i className="fa fa-fw fa-arrow-right"></i>&nbsp; <FormattedMessage defaultMessage="Flow Definitions" id="flowDefs.list" /></Link></li>);
        }
        if (BrowserPermission.hasPermission(Permission.PERM_INSTANCE_VIEW) && BrowserPermission.developerModeEnabled()) {
            if (this.props.user.instance) {
                logged.push(<li className="nav-divider" key="separator5" role="separator"></li>);
                logged.push(<li key="instance-view"><Link {...linkProps} to={urlMapping.getUrl(types['instances'], 'view', this.props.user.instance)}><ChannelIcon channelDef={{icon: this.props.user.instance.logo}} size={24}/>&nbsp;&nbsp; {this.props.user.instance.name}</Link></li>);
                logged.push(<li key="instance-users"><Link {...linkProps} to={urlMapping.getUrl(types['users'], 'instance-list', this.props.user.instance)}><i className="fa fa-fw fa-user-times"></i>&nbsp; <FormattedMessage defaultMessage="Users" id="menu.instanceUsers" /></Link></li>);
                logged.push(<li key="instance-organisations"><Link {...linkProps} to={urlMapping.getUrl(types['organisations'], 'instance-list', this.props.user.instance)}><i className="fa fa-fw fa-organisation-times"></i>&nbsp; <FormattedMessage defaultMessage="Organisations" id="menu.instanceOrganisations" /></Link></li>);
                logged.push(<li className="nav-divider" key="separator3" role="separator"></li>);
            }
            if (this.props.user.instance) {
                logged.push(<li key="instances"><Link {...linkProps} to={urlMapping.getUrl(types['instances'], 'list')}><i className="fa fa-fw fa-square-o"></i>&nbsp; <FormattedMessage defaultMessage="Instances" id="menu.instances" /></Link></li>);
            }
            logged.push(<li className="nav-divider" key="separator4" role="separator"></li>);
        }

        const feedbackLink = this.props.currentOrganisation
            ? `https://docs.google.com/forms/d/e/1FAIpQLScbM5EwZmIxVvYMpmxOi6zwsYhbVZahtFUO5hzeBj9_oipi7w/viewform?usp=pp_url&entry.121282655=${this.props.currentOrganisation.realId}&entry.1312277406=${this.props.currentOrganisation.name}`
            : 'https://docs.google.com/forms/d/e/1FAIpQLScbM5EwZmIxVvYMpmxOi6zwsYhbVZahtFUO5hzeBj9_oipi7w/viewform';

        if (!BrowserPermission.developerModeEnabled()) {
            loggedBottom.push(<li className="nav-item" key="feedback"><a href={feedbackLink} target="_blank"><i className="fa fa-fw fa-bullhorn"></i>&nbsp; <FormattedMessage defaultMessage="Give us your opinion" id="feedback.shortText" /></a></li>);
            if (this.props.user.instance && this.props.user.instance.supportUrl) {
                loggedBottom.push(<li className="nav-item" key="support"><a href={this.props.user.instance.supportUrl} target="_blank"><i className="fa fa-fw fa-support"></i>&nbsp; <FormattedMessage defaultMessage="Support" id="main.support" /></a></li>);
            } else {
                loggedBottom.push(<li className="nav-item" key="support"><a href={config.PUBLIC_WEB_URL + "/" + getLocale() + "/support/"} target="_blank"><i className="fa fa-fw fa-support"></i>&nbsp; <FormattedMessage defaultMessage="Support" id="main.support" /></a></li>);
            }
            loggedBottom.push(<li key="version"><div className="app-footer-version"><FormattedMessage defaultMessage="Version:" id="main.versionLabel" /> {config.VERSION}</div></li>);

        } else {
            logged.push(<li className="nav-item" key="feedback"><a href={feedbackLink} target="_blank"><i className="fa fa-fw fa-bullhorn"></i>&nbsp; <FormattedMessage defaultMessage="Give us your opinion" id="feedback.shortText" /></a></li>);
            if (this.props.user.instance && this.props.user.instance.supportUrl) {
                logged.push(<li className="nav-item" key="support"><a href={this.props.user.instance.supportUrl} target="_blank"><i className="fa fa-fw fa-support"></i>&nbsp; <FormattedMessage defaultMessage="Support" id="main.support" /></a></li>);
            } else {
                logged.push(<li className="nav-item" key="support"><a href={config.PUBLIC_WEB_URL + "/" + getLocale() + "/support/"} target="_blank"><i className="fa fa-fw fa-support"></i>&nbsp; <FormattedMessage defaultMessage="Support" id="main.support" /></a></li>);
            }
            logged.push(<li key="version"><div className="app-footer-version"><FormattedMessage defaultMessage="Version:" id="main.versionLabel" /> {config.VERSION}</div></li>);
        }

        return (
            <div>
                <ul className="nav nav-sidebar">
                    {logged}
                </ul>

                <ul className="nav nav-sidebar nav-sidebar-bottom">
                    {loggedBottom}
                </ul>
            </div>
        );
    }
}

export default Relay.createContainer(LeftNavRoot, {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                instance {
                    id,
                    realId,
                    name,
                    logo,
                    supportEmail,
                    supportUrl,
                },
                ${EventTracker.getFragment()}
            }
        `,
    },
});
